import * as BizCharts from 'bizcharts';

const CURRENT_END_TRIM_PX = 11;
const PREVIOUS_END_TRIM_PX = 9;
const ARROW_LENGTH_PX = 13;
const ARROW_HALF_ANGLE_RAD = (30 * Math.PI) / 180;

(BizCharts as any).G2.registerShape('edge', 'comparison-connector', {
	draw(cfg: any, container: any) {
		const rawPoints = cfg.points || [];
		const points =
			typeof this.parsePoints === 'function'
				? this.parsePoints(rawPoints)
				: rawPoints.map((point: any) => this.parsePoint(point));
		const start = points[0];
		const end = points[1];
		if (
			!start ||
			!end ||
			!Number.isFinite(start.x) ||
			!Number.isFinite(start.y) ||
			!Number.isFinite(end.x) ||
			!Number.isFinite(end.y)
		) {
			return container.addGroup();
		}
		const dx = end.x - start.x;
		const dy = end.y - start.y;
		const length = Math.sqrt(dx * dx + dy * dy) || 1;
		const ux = dx / length;
		const uy = dy / length;
		const maxTrim = Math.max(0, length / 2 - 1);
		const startTrim = Math.min(PREVIOUS_END_TRIM_PX, maxTrim);
		const endTrim = Math.min(CURRENT_END_TRIM_PX, maxTrim);
		const sx = start.x + ux * startTrim;
		const sy = start.y + uy * startTrim;
		const tipX = end.x - ux * endTrim;
		const tipY = end.y - uy * endTrim;
		const style = cfg.style || {};
		const stroke = style.stroke;
		const lineWidth = style.lineWidth || 2;
		const strokeOpacity =
			style.strokeOpacity === null || style.strokeOpacity === undefined ? 1 : style.strokeOpacity;

		const bx = -ux;
		const by = -uy;
		const cos = Math.cos(ARROW_HALF_ANGLE_RAD);
		const sin = Math.sin(ARROW_HALF_ANGLE_RAD);
		const w1x = tipX + ARROW_LENGTH_PX * (bx * cos - by * sin);
		const w1y = tipY + ARROW_LENGTH_PX * (bx * sin + by * cos);
		const w2x = tipX + ARROW_LENGTH_PX * (bx * cos + by * sin);
		const w2y = tipY + ARROW_LENGTH_PX * (-bx * sin + by * cos);

		const group = container.addGroup();
		group.addShape('line', {
			attrs: {
				x1: sx,
				y1: sy,
				x2: tipX,
				y2: tipY,
				stroke,
				strokeOpacity,
				lineWidth,
				lineCap: 'round',
			},
		});
		group.addShape('path', {
			attrs: {
				path: [
					['M', w1x, w1y],
					['L', tipX, tipY],
					['L', w2x, w2y],
				],
				stroke,
				strokeOpacity,
				lineWidth,
				lineCap: 'round',
				lineJoin: 'round',
			},
		});
		return group;
	},
});
